import Regex from '../constants/regex';
/**
 *
 * Decode comment strin to html (reverse of getEncodedComment)
 * @param {string} commentDes
 *
 * @output -> <span class="mention" data-index="0" data-denotation-char="@" data-value="Loveleet Joshi" data-id="jdshfhrui3857r73">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">@<\/span>Loveleet Joshi<\/span>&#xFEFF;<\/span>
 * @input -> @[Loveleet Joshi](userId:jdshfhrui3857r73)
 */
export const getDecodedComment = (comment) => {
  const regex = Regex.decodeComment;
  const mentions = [...comment.matchAll(Regex.detectAllMentionsInComment)];
  mentions.map(mention => {
    const userName = mention[1];
    //eslint-disable-next-line
    const userId = mention[2];
    comment = comment.replace(
      regex,
      `<span class="mention" data-index="0" data-denotation-char="@" data-value="${userName}" data-id="${userId}">﻿<span contenteditable="false"><span class="ql-mention-denotation-char">@</span>${userName}</span>﻿</span>`
    );
  });
  return comment;
};

/**
 *
 * Encode comment html to string
 * @param {string} commentDes
 *
 * @input -> <span class="mention" data-index="0" data-denotation-char="@" data-value="Loveleet Joshi" data-id="jdshfhrui3857r73">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">@<\/span>Loveleet Joshi<\/span>&#xFEFF;<\/span>
 * @output -> @[Loveleet Joshi](userId:jdshfhrui3857r73)
 */
export const getEncodedComment = (commentDes) => {
  commentDes = commentDes.replaceAll('<p>', '');
  commentDes = commentDes.replaceAll('</p>', '');
  const regex = Regex.encodeComment;
  let encodedString = commentDes;
  let result = encodedString.match(regex);
  while (result) {
    encodedString = encodedString.replace(
      regex,
      //eslint-disable-next-line
      `@[${result[1]}](userId:${result[2]})`
    );
    result = encodedString.match(regex);
  }
  return encodedString;
};
